import React from 'react';
import { isEmpty, kebabCase } from 'lodash';
import { motion } from 'framer-motion';
import BoxedContainer from '../components/layouts/BoxedContainer';
import ActivitiesCard from '../components/activities-card/ActivitiesCard';
import Button from '../components/layouts/Button';

export default function ActivitiesBlock({ data }) {
  const {
    title,
    description,
    membershipButton,
    cardTitle,
    cardText,
    cardPrice,
    dswFitnessActivitiesList,
  } = data;

  return (
    <section className="bg-bg-1 lg:pt-[95px] pt-[70px] lg:pb-[220px] pb-[90px] overflow-hidden">
      <BoxedContainer className="boxed">
        <div className="flex flex-col lg:gap-y-[59px] gap-y-[30px]">
          {isEmpty(title) || (
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: 0.4 }}
              viewport={{ once: true }}
              className="4xl:pl-[200px] 2xl:pl-[100px] lg:pl-[50px] md:pl-[30px]
              flex md:flex-row flex-col gap-x-[70px] gap-y-[35px]">
              <div
                className={`flex flex-col md:gap-y-[58px] gap-y-[20px] ${
                  cardTitle ? '3xl:w-[46%] md:w-[54%] w-full' : ''
                }`}>
                <div id={kebabCase(title)} className="flex flex-col lg:gap-y-[30px] gap-y-[10px]">
                  <h3
                    className="text-primary font-roboto-condensed-bold 2xl:text-2xl lg:text-[38px]
                    lg:leading-[55px] text-[35px] leading-[45px]  uppercase">
                    {title}
                  </h3>
                  {isEmpty(description) || (
                    <p
                      className="max-w-[770px] font-roboto-regular lg:text-base text-[15px]
                    leading-6 text-primary">
                      {description}
                    </p>
                  )}
                </div>
                {isEmpty(membershipButton) || (
                  <Button
                    label={membershipButton.name}
                    url={membershipButton.url}
                    ariaLabel={membershipButton.name}
                    tagName={kebabCase(membershipButton.name)}
                    variant="primaryRed"
                    text="w-fit"
                  />
                )}
              </div>
              {isEmpty(cardTitle) || (
                <div className="md:w-[270px] h-[120px] bg-white lg:mt-[100px] md:mt-[100px]">
                  <h3
                    className="font-roboto-condensed-bold bg-bg-10 h-[40px] text-white uppercase
                              flex items-center px-[20px] text-[16px] leading-[24px]">
                    {cardTitle}
                  </h3>
                  <div
                    className="flex flex-row justify-between items-center bg-white
                            px-[20px] h-[80px]">
                    <p className="font-roboto-regular text-primary text-[16px] leading-[24px]">
                      {cardText}
                    </p>
                    <p className="font-roboto-bold text-red text-base uppercase">{cardPrice}</p>
                  </div>
                </div>
              )}
            </motion.div>
          )}

          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.6 }}
            viewport={{ once: true }}
            className="flex flex-col gap-y-[18px]">
            {isEmpty(dswFitnessActivitiesList) ||
              dswFitnessActivitiesList.map((activity, index) => (
                <ActivitiesCard key={index} data={activity.content} />
              ))}
          </motion.div>
        </div>
      </BoxedContainer>
    </section>
  );
}
